import React, { useState } from "react";
import axios from "axios";
import { useNavigate } from "react-router-dom";

function Login() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [error, setError] = useState("");
  const navigate = useNavigate();

  const handleSubmit = async (e) => {
    e.preventDefault();
    try {
      const res = await axios.post("/api/auth/login", { email, password });
      localStorage.setItem("token", res.data.token);
      navigate("/dashboard");
    } catch (err) {
      setError(err.response?.data?.error || "Алдаа гарлаа");
    }
  };

  return (
    <div className="page">
      <h1>Нэвтрэх</h1>
      {error && <p className="error">{error}</p>}
      <form onSubmit={handleSubmit}>
        <input type="email" placeholder="Имэйл" value={email} onChange={(e) => setEmail(e.target.value)} required />
        <input type="password" placeholder="Нууц үг" value={password} onChange={(e) => setPassword(e.target.value)} required />
        <button type="submit">Нэвтрэх</button>
      </form>
    </div>
  );
}

export default Login;
